'use client';

import { cn } from '@/lib/utils';
import React, { createContext, HTMLAttributes, ReactNode, useId, useState } from 'react';
import styles from './accordionExperience.module.scss';

type AccordionContextType = {
  allowMultiple: boolean;
  openItems: string[];
  instance: string;
  toggleItem: (id: string) => void;
};

type AccordionProps = {
  children: ReactNode;
  allowMultiple?: boolean;
  defaultOpen?: string[];
};

type AccordionExperienceItemProps = {
  index: number;
  title: string;
  // eslint-disable-next-line
  content: any;
};

export const AccordionContext = createContext<AccordionContextType | null>(null);

export const AccordionExperience = ({
  children,
  allowMultiple = false,
  defaultOpen = [],
  className,
  ...props
}: AccordionProps & HTMLAttributes<HTMLDivElement>) => {
  const [openItems, setOpenItems] = useState<string[]>(defaultOpen);

  const toggleItem = (id: string) => {
    if (allowMultiple) {
      setOpenItems((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
      );
    } else {
      setOpenItems((prev) => (prev.includes(id) ? [] : [id]));
    }
  };

  const instance = useId();

  return (
    <AccordionContext.Provider value={{ allowMultiple, openItems, toggleItem, instance }}>
      <div role="presentation" className={cn(styles.component, className, 'accordion')} {...props}>
        {React.Children.map(children, (child, index) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child as React.ReactElement<AccordionExperienceItemProps>, {
              index,
            });
          }
          // return index;
          // return child;
        })}
      </div>
    </AccordionContext.Provider>
  );
};
